import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { NotaFiscal } from '../../../../types/notafiscal.type';
import { ProcessoNotaFiscal } from '../../../../types/ProcessoNotaFiscal.type';

@Injectable({
  providedIn: 'root'
})
export class NotafiscalService {

  constructor(private configService: ConfigService, private httpClient: HttpClient) { }

  getNotaFiscals(instancias: string, dataInicial: string | null, dataFinal: string | null, processos: string | null) {
    return this.httpClient.get<NotaFiscal[]>(`${this.configService.getApiUrlRoot()}/notasfiscais/?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}&processos=${processos}`)
  }

  postSolicitaNotaFiscal(instancias: string, dataInicial: string | null, dataFinal: string | null, processos: string | null) {
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/notasfiscais/pims/buscar?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}&processos=${processos}`)
  }

  getIntegraNotaFiscal(corpo: any) {
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/notasfiscais/integracao`, corpo)
  }

  postIntegraNotaFiscalTaxa(corpo: any) {
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/notasfiscais/taxas`, corpo)
  }

  exportarNotaFiscal(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/notasfiscais/relatorios/exportar`, corpo, { responseType: 'blob'})
  }

  postCancelarNF(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/notasfiscais/cancelar`, corpo)
  }

  postEstornarNF(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/notasfiscais/estornar`, corpo)
  }

  postCancelarTaxa(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/notasfiscais/taxas/cancelarTaxa`, corpo)
  }

  getProcessos() {
    return this.httpClient.get<ProcessoNotaFiscal[]>(`${this.configService.getApiUrlRoot()}/notasfiscais/processos`)
  }

  postCancelarEstornarNF(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/notasfiscais/cancelar-estornar `, corpo)
  }
}
